export function Logo({ className }) {
    return (
        <div className={"logo h-full w-full min-h-[24px] min-w-[24px] " + className} />
    );
}